<template>
  <b-container fluid class="h-100-trim-header-footer" id="tailie-download">
    <b-row class="h-100">
      <b-col md="5" class="h-100 padding-left">
        <b-img src="~/../assets/images/tailie-phone.png" fluid-grow></b-img>
      </b-col>
      <b-col md="7">
        <h1 id="tailieDownloadTitle">{{ mainTitle }}</h1>
        <b-row id="TailieDownloadSteps">
          <b-col
            md="6"
            v-for="(mainStep, index) in mainSteps"
            v-bind:key="mainStep.text"
          >
            <b-row>
              <b-col md="2" class="col-lg-1">
                <b-badge variant="primary" pill id="tailieDownloadBall">
                  {{ index + 1 }}
                </b-badge>
              </b-col>
              <b-col md="10" class="col-lg-5">
                <span class="tailieDownloadText">{{ mainStep.text }}</span>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="tailieDownloadGreyBox hidden-md-down" align-v="center">
          <b-col md="7">
            <p>{{ mainQrText }}</p>
          </b-col>
          <b-col md="5">
            <b-img
              src="~/../assets/images/tailie-qr.png"
              fluid
              class="img-fluid"
              id="tailieDownloadQR"
            ></b-img>
          </b-col>
        </b-row>
        <b-row class="tailieDownloadGreyBox" align-v="center">
          <b-col md="7">
            <p>{{ mainStoreText }}</p>
          </b-col>
          <b-col md="5">
            <a
              href="https://apps.apple.com/nl/app/tailie/id1437534745"
              target="_blank"
            >
              <AppleAppStore id="tailieDownloadAppStore" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.dreszcode.tailie&hl=nl"
              target="_blank"
            >
              <GooglePlay id="tailieDownloadPlayStore" />
            </a>
          </b-col>
        </b-row>
        <b-row>
          <b-button
            variant="link"
            @click="$router.push({ name: 'overview' })"
            class="tailieBlueUnderline"
          >
            {{ mainBackButtonText }}
          </b-button>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import AppleAppStore from "../assets/images/apple-app-store.svg";
import GooglePlay from "../assets/images/google-play.svg";

export default {
  name: "pages-mobile",
  components: {
    AppleAppStore,
    GooglePlay
  },
  data() {
    return {
      mainTitle: "Download the Tailie app and get your own size passport!",
      mainSteps: [
        { text: "Download the app" },
        { text: "Easily create a size passport in less than 10 minutes." },
        { text: "It's shopping without worrying time!" }
      ],
      mainQrText: "Scan the QR-code with your phone",
      mainStoreText: "Or go directly to your store",
      mainBackButtonText: "Back"
    };
  },
  created() {
    // this.$store.dispatch("ui/setSize", {
    //   width: 900,
    //   height: 700
    // });
  }
};
</script>
